<app-merchant-details
  [identity]="identity"
  [merchant]="merchant"
  [merchants]="recentMerchants"
></app-merchant-details>
<div class="container">
  <div class="card card-nc" style="background-color: #fff">
    <div _ngcontent-c10="" class="card-heading">
      <span _ngcontent-c10="" class="fa fa-file"></span
      ><span _ngcontent-c10="" class="cardHeaderHeading">Merchant Forms</span>
    </div>
    <div style="margin: 0 1rem 1rem 1rem">
      <div style="margin-top: 1.5rem; font-weight: normal">
        Choose form for upload. Total size not to exceed TBD MB. PDF files only.
      </div>
      <div class="error" style="min-height: 1rem; margin: 0; padding: 0">
        <strong *ngIf="error !== '' && file === null">{{ error }}</strong>
      </div>
      <div *ngIf="file === null">
        <app-file-uploader
          [maxFileSize]="10 * 1024 * 1024"
          (onError)="setError($event)"
          (fileDropped)="fileSelected($event)"
        ></app-file-uploader>
      </div>

      <div *ngIf="file !== null" style="min-width: 400px; max-width: 550px">
        <div
          class="alert alert-primary"
          style="margin-bottom: 3px; margin-top: 2rem"
        >
          <span style="font-weight: 600; color: black">Selected File</span>
          <span
            (click)="cancel()"
            class="pull-right"
            style="
              text-decoration: underline;
              font-weight: 600;
              cursor: pointer;
            "
            >Change file</span
          >
        </div>
        <div class="alert alert-primary d-flex align-items-center">
          <i class="fa fa-file-pdf-o fa-2x"></i>&nbsp;&nbsp;<span
            style="color: #000"
            >{{ file.name }}</span
          >
        </div>
      </div>

      <button
        [disabled]="file === null || uploading"
        style="margin-top: 1rem"
        class="btn btn-primary"
        (click)="uploadForm()"
      >
        Upload
        <span *ngIf="uploading"
          >&nbsp;<i class="fa fa-spinner fa-spin"></i
        ></span>
      </button>
    </div>
  </div>
  <div
    *ngIf="retrievingForms || pagedMerchantForms.length > 0"
    class="card merchant-forms"
  >
    <div style="padding: 1.5rem" *ngIf="retrievingForms">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
    </div>
    <div *ngFor="let form of pagedMerchantForms" class="merchant-form">
      <h6 class="merchant-form-header">
        <a class="merchant-form-link" (click)="getEnrollmentForm(form, $event)">
          {{ form.fileName }}
        </a>
      </h6>
      <div>
        Upload date: {{ form.formDate | date: 'MM/dd/yyyy' }} |
        {{ form.formDate | date: 'mediumTime' }} | File Type: PDF
      </div>
    </div>
    <div
      *ngIf="
        (merchantForms && merchantForms.length > itemsPerPage) ||
        itemsPerPage > 10
      "
      style="margin-top: 1rem"
      class="d-flex align-items-center"
    >
      <app-pagination
        (pageSet)="pageSet($event)"
        [totalItems]="merchantForms.length"
        [itemsPerPage]="itemsPerPage"
        [currentPage]="page"
      >
      </app-pagination>
      <div
        class="form-group d-flex align-items-center"
        style="margin-left: 1.5rem"
      >
        <label
          style="
            font-weight: normal;
            font-size: 0.75rem;
            margin-bottom: 0;
            margin-right: 0.75rem;
          "
          for="itemsPerPage"
          >Items per page</label
        >
        <select
          style="padding: 1rem"
          class="form-control"
          id="itemsPerPage"
          (change)="setItemsPerPage($event)"
          style="
            width: 45px;
            height: 30px;
            padding: 0;
            border-radius: 3px;
            border-color: #dee2e6;
            font-size: 0.75rem;
          "
        >
          <option [selected]="itemsPerPage === 10" value="10">10</option>
          <option [selected]="itemsPerPage === 25" value="25">25</option>
          <option [selected]="itemsPerPage === 100" value="100">100</option>
        </select>
      </div>
    </div>
  </div>
</div>
